import axios from "axios";
import Cookies from "js-cookie";

// Define module-specific base URLs
const BASE_URLS = {
  auth: process.env.REACT_APP_API_AUTH_URL,
  ccp: process.env.REACT_APP_API_CCP_URL,
  qcp: process.env.REACT_APP_API_QCP_URL,
  batchIntake: process.env.REACT_APP_API_BATCH_URL,
  statsAPi: process.env.REACT_APP_API_STAT_URL,
  monitorAPi: process.env.REACT_APP_API_MON_URL,
};

// Function to create an Axios instance
const createApiClient = (baseURL) => {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  // Request Interceptor: Attach Access Token
  instance.interceptors.request.use(
    (config) => {
      const accessToken = Cookies.get("accessToken");
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response Interceptor: Handle Token Expiry & Refresh
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const refreshToken = Cookies.get("refreshToken");
          if (!refreshToken) throw new Error("No refresh token available");

          const { data } = await axios.post(
            `${BASE_URLS.auth}/auth/refresh`,
            { token: refreshToken },
            { withCredentials: true }
          );

          Cookies.set("accessToken", data.accessToken, {
            secure: true,
            sameSite: "Strict",
          });
          Cookies.set("refreshToken", data.refreshToken, {
            secure: true,
            sameSite: "Strict",
          });

          originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
          return instance(originalRequest);
        } catch (err) {
          Cookies.remove("accessToken");
          Cookies.remove("refreshToken");
          window.location.href = "/login";
          return Promise.reject(err);
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

// Export instances for different modules
const authApi = createApiClient(BASE_URLS.auth);
const ccpApi = createApiClient(BASE_URLS.ccp);
const qcpApi = createApiClient(BASE_URLS.qcp);
const batchIntakeApi = createApiClient(BASE_URLS.batchIntake);
const statsAPI = createApiClient(BASE_URLS.statsAPi);
const monitorAPI = createApiClient(BASE_URLS.monitorAPi);

export { authApi, ccpApi, qcpApi, batchIntakeApi, statsAPI, monitorAPI };
